import { apiClient } from './client'

export interface FaxNumber {
  id: string
  facility_id: string
  fax_number: string
  type: string
  createdAt: string
  updatedAt: string
  deletedAt: string | null
}

export interface FaxNumbersResponse {
  success: boolean
  data: {
    faxNumbers: FaxNumber[]
    total: number
  }
}

export interface FaxNumberMutationResponse {
  success: boolean
  data: {
    message: string
    faxNumber: FaxNumber
  }
}

export interface DeleteFaxNumberResponse {
  success: boolean
  data: {
    message: string
  }
}

export interface CreateFaxNumberRequest {
  faxNumber: string
  type?: string
}

export interface UpdateFaxNumberRequest {
  faxNumber: string
}

export const hospitalFaxNumbersApi = {
  listFaxNumbers: async (hospitalId: string): Promise<FaxNumbersResponse> => {
    const response = await apiClient.get<FaxNumbersResponse>(
      `/hospitals/${hospitalId}/fax-numbers`
    )
    return response.data
  },

  createFaxNumber: async (
    hospitalId: string,
    data: CreateFaxNumberRequest
  ): Promise<FaxNumberMutationResponse> => {
    const response = await apiClient.post<FaxNumberMutationResponse>(
      `/hospitals/${hospitalId}/fax-numbers`,
      data
    )
    return response.data
  },

  updateFaxNumber: async (
    hospitalId: string,
    faxId: string,
    data: UpdateFaxNumberRequest
  ): Promise<FaxNumberMutationResponse> => {
    const response = await apiClient.patch<FaxNumberMutationResponse>(
      `/hospitals/${hospitalId}/fax-numbers/${faxId}`,
      data
    )
    return response.data
  },

  deleteFaxNumber: async (
    hospitalId: string,
    faxId: string
  ): Promise<DeleteFaxNumberResponse> => {
    const response = await apiClient.delete<DeleteFaxNumberResponse>(
      `/hospitals/${hospitalId}/fax-numbers/${faxId}`
    )
    return response.data
  },
}
